import { components, MultiValueGenericProps } from "react-select";

const MultiValueContainer = (
  props: MultiValueGenericProps<{ value: string; label: string }>
) => {
  return (
    <components.MultiValueContainer
      {...props}
      innerProps={{
        ...props.innerProps,
        className: props.innerProps.className,
      }}
    />
  );
};

export default MultiValueContainer;
